import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  ogImage?: string;
  canonical?: string;
  ogType?: string;
}

export function useDocumentMeta({ title, description, ogImage, canonical, ogType }: MetaOptions) {
  useEffect(() => {
    if (!title) return;

    document.title = title;

    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (ogType) setMeta("property", "og:type", ogType);
    if (ogImage) setMeta("property", "og:image", ogImage);
    if (canonical) {
      setMeta("property", "og:url", canonical);
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (ogImage) setMeta("name", "twitter:image", ogImage);
  }, [title, description, ogImage, canonical, ogType]);
}
